import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SelectEventTicketTypePage } from 'src/app/modals/select-event-ticket-type/select-event-ticket-type.page';

const routes: Routes = [
  {
    path: '',
    component: SelectEventTicketTypePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SelectEventTicketTypePage]
})
export class SelectEventTicketTypePageModule {}
